import { Fragment, useState } from "react";
import Slider from "../atoms/Slider";
import { Dialog, DialogContent } from "@material-ui/core";
import { CheckSpFlag } from "../../hooks/CheckSpFlag";
import { MAX_COMMENT_IMAGES } from "../../utils/constants/comment";

type ImageSliderProps = {
  imageUrls: string[];
  maxDisplay?: number;
  className?: any;
};

const ImageSlider = ({
  imageUrls = [],
  maxDisplay = MAX_COMMENT_IMAGES,
  className,
}: ImageSliderProps) => {
  const isSp = CheckSpFlag();
  const [openSrc, setOpenSrc] = useState("");

  const handleOpen = (src: string) => setOpenSrc(src);
  const handleClose = () => setOpenSrc("");

  if (!imageUrls || imageUrls.length === 0) return null;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  return (
    <Fragment>
      <Slider {...settings}>
        {Array.from({ length: maxDisplay }).map((_, index: number) => {
          const src = imageUrls[index];
          if (!src) {
            return isSp ? null : <div key={`${src}-${index}`} />;
          }

          return (
            <img
              src={src}
              key={`${src}-${index}`}
              alt={`${src}-${index}`}
              className={`${className.boardBodyImage} forum-board-image`}
              onClick={() => handleOpen(src)}
            />
          );
        })}
      </Slider>

      <Dialog open={!!openSrc} onClose={handleClose}>
        <DialogContent className={className.imageContainer}>
          <img
            key={`${openSrc}`}
            src={openSrc}
            alt="full"
            className={className.screenImage}
            onClick={handleClose}
          />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default ImageSlider;